/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 10/10/2023
 */
import React from "react"
import {
  Button,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material"
import {
  Group,
  GroupAdd,
  GroupRemove,
  GroupWork,
  Groups,
  Groups2,
  Groups3,
  Diversity1,
  Diversity2,
  Diversity3,
  PeopleAlt,
  PeopleOutline,
  Workspaces,
  AcUnit,
  AddReaction,
  Apartment,
  Attractions,
  AutoAwesome,
  AutoFixHigh,
  AutoGraph,
  BrightnessHigh,
  BrightnessAuto,
  CatchingPokemon,
  BlurOn,
  Fitbit,
  FlashOn,
  Fort,
  Grade,
  Hive,
  Hub,
  OfflineBolt,
  Stars,
  SupervisedUserCircle,
} from "@mui/icons-material"

const iconComponents = {
  Group,
  GroupAdd,
  GroupRemove,
  GroupWork,
  Groups,
  Groups2,
  Groups3,
  Diversity1,
  Diversity2,
  Diversity3,
  PeopleAlt,
  PeopleOutline,
  Workspaces,
  AcUnit,
  AddReaction,
  Apartment,
  Attractions,
  AutoAwesome,
  AutoFixHigh,
  AutoGraph,
  BrightnessHigh,
  BrightnessAuto,
  CatchingPokemon,
  BlurOn,
  Fitbit,
  FlashOn,
  Fort,
  Grade,
  Hive,
  Hub,
  OfflineBolt,
  Stars,
  SupervisedUserCircle,
}

const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text
  }
  return text.substr(0, maxLength) + "..."
}

const IconSelectionModal = ({ open, handleClose, handleIconSelect }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ bgcolor: "#116c6f", color: "white" }}>
        Select Group Icon
      </DialogTitle>
      <Divider sx={{ borderBottomWidth: 5 }} />
      <Grid container spacing={1} justifyContent="center">
        {Object.keys(iconComponents).map((iconKey, index) => (
          <Grid item xs={2} sx={{ ml: 2 }}>
            <IconButton
              aria-label={iconKey}
              onClick={() => handleIconSelect(iconKey, iconComponents[iconKey])}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "0",
                margin: "10px",
              }}>
              {React.createElement(iconComponents[iconKey], {
                fontSize: "large",
              })}
              <Typography variant="caption" style={{ fontSize: "10px" }}>
                {truncateText(iconKey, 10)}
              </Typography>
            </IconButton>
          </Grid>
        ))}
      </Grid>
      <Button onClick={handleClose} variant="contained" color="error">
        Cancel
      </Button>
    </Dialog>
  )
}

export default IconSelectionModal
